import KeyValueListDisplay from '@/components/KeyValueDisplay';
import { convertISODateToMMDDYYYY } from '@/lib/utils';
import type { DdiWorkOrderDetailResponse } from '@/types/dueDiligence.types';

type Props = {
  clientDetails: DdiWorkOrderDetailResponse['clientDetails'];
};

export const CaseDetailsDdiContent = ({ clientDetails }: Props) => {
  const caseDetails = [
    { label: 'Entry Date', value: convertISODateToMMDDYYYY(clientDetails.entryDate) },
    { label: 'Service Type', value: clientDetails.serviceType },
    { label: 'DDI Type', value: clientDetails.ddiType },
    ...(clientDetails.ddiSubtype ? [{ label: 'DDI Sub-type', value: clientDetails.ddiSubtype }] : []),
    { label: "Contact's Name", value: clientDetails.contactName },
    { label: "Contact's Email Address", value: clientDetails.contactEmail },
    { label: 'Lawyer', value: clientDetails.lawyerName ?? '-' },
    { label: 'File Number', value: clientDetails.fileNumber },
    { label: 'Court', value: clientDetails.courtName ?? '-' },
    { label: 'Case Number', value: clientDetails.caseNumber },
    { label: 'Case Name', value: clientDetails.caseName },
    { label: 'Case Type', value: clientDetails.caseType },
    { label: 'Case Sub-Type', value: clientDetails.caseSubType },
  ];

  return (
    <div className="flex flex-col gap-2 w-full px-6 py-6 text-sm">
      <KeyValueListDisplay data={caseDetails} />
    </div>
  );
};

export default CaseDetailsDdiContent;
